export default "__VITE_ASSET__hdT4wsXl__"